import {Component, OnInit} from '@angular/core';
import {TemplateComponent} from "../../template/template.component";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-developers-help',
  standalone: true,
  imports: [
    NgIf
  ],
  templateUrl: './developers-help.component.html',
  styleUrl: './developers-help.component.css'
})
export class DevelopersHelpComponent extends TemplateComponent implements OnInit{
  developerBar:any;
  ngOnInit() {
    if (this.global.getMainData()['main-page'] != null) {
      this.developerBar = JSON.parse(this.global.getMainData()['main-page']['data'])['developer-bar'];
    }
  }
}
